// retrieve gameNetwork & gameContractAddress to pass to the server
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

export default function useNetworkTxnParam() {
  const [gameParam, setGameParam] = useState({
    gameNetwork: "",
    gameContractAddress: "",
  });
  const { gameId } = useParams();

  useEffect(() => {
    if (gameId) {
      const [gameNetwork, gameContractAddress] = gameId.split("-");
      setGameParam({ gameNetwork, gameContractAddress });
    } else {
      setGameParam({ gameNetwork: "", gameContractAddress: "" });
    }
  }, [gameId]);

  return gameParam;
}
